export type ClipboardPasteSegment =
  | { kind: 'html'; html: string }
  | { kind: 'markdown'; text: string }
  | { kind: 'image'; dataUri: string };

export const DATA_IMAGE_URI_PATTERN = /data:image\/[^;]+;base64,[A-Za-z0-9+/=]+/g;

/** Markdown image whose URL is a data URI; optional CommonMark title (`" =WxH"`) is not part of the URI. */
export const MARKDOWN_DATA_IMAGE_PATTERN = /!\[[^\]]*\]\((data:image\/[^\s)]+)(?:\s+"[^"]*")?\)/g;
